import { IApplicationState } from '../../types/redux';

export const getUtmSource = (state: IApplicationState): string | null => state.utmSource;
